import React, { Component } from 'react';
import { Breakpoint, ModalType } from '@philips-internal/oswald-ui-constants';
import { ApplicationContext } from '@philips-internal/oswald-ui-core/lib/component/context/index.js';
import { getBreakpoint, isFunction } from '@philips-internal/oswald-ui-utils';
import { Mapper } from '../../mapper/mapper.js';
import { Modal } from '../../modal/modal.js';
import { SelectableIterator } from '../../selectable-iterator/selectable-iterator.js';
import { Text } from '../../text/text.js';
class TableCustomizeModal extends Component {
    componentDidMount() {
        const { onClose } = this.props;
        this.popNavigationItem = this.context?.pushNavigationItem(onClose);
    }
    componentWillUnmount() {
        if (isFunction(this.popNavigationItem)) {
            this.popNavigationItem();
        }
    }
    isMobile() {
        const breakpoint = getBreakpoint();
        return breakpoint === Breakpoint.SM || breakpoint === Breakpoint.XSM;
    }
    render() {
        const { data, primaryKey, onClose, onSelect, onSort, selected } = this.props;
        const modalType = this.isMobile() ? ModalType.FULLSCREEN : ModalType.DIALOG;
        return (React.createElement(Modal, { onClose: onClose, type: modalType },
            React.createElement(SelectableIterator, { data: data, done: true, loading: false, multiselect: true, onSelect: onSelect, onSort: onSort, primaryKey: primaryKey, selected: selected, sortable: true, uuid: "fake-uuid" },
                React.createElement(Mapper, { map: { value: 'value' } },
                    React.createElement(Text, null)))));
    }
}
TableCustomizeModal.contextType = ApplicationContext.Context;
export { TableCustomizeModal, };
//# sourceMappingURL=table-customize-modal.js.map